export default {
  token: null,
  clientsSearched: [],
  clientsSearchFields: null,
  reservesSearched: [],
  reservesSearchFields: null
}